export default "__VITE_ASSET__BRJE_pSZ__"